import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { PurchaseInvoiceModel } from '../model/index';

@Injectable()
export class PurchaseInvoiceService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private purchaseInvoiceUrl = 'api/purchaseInvoice';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPurchaseInvoiceList(query: any): Promise<PurchaseInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseInvoiceUrl}/getPurchaseInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPurchaseInvoiceDetailList(query: any): Promise<PurchaseInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseInvoiceUrl}/getPurchaseInvoiceDetailList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong, Please Contact System Admin'
                };
                this.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }

    checkSrf(query: any): Promise<PurchaseInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseInvoiceUrl}/checkSrf`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong, Please Contact System Admin'
                };
                this.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }

    addPurchaseInvoice(query: any): Promise<PurchaseInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseInvoiceUrl}/addPurchaseInvoice`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    } 
     getModelDetails(query: any): Promise<PurchaseInvoiceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseInvoiceUrl}/getModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deleteGridList(rowData: any): Promise<PurchaseInvoiceModel> {
        const url = `${this.purchaseInvoiceUrl}/deleteGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseInvoiceModel)
            .catch(this.handleError);
    }

    deletePurchaseInvoiceEntry(rowData: any): Promise<PurchaseInvoiceModel> {
        const url = `${this.purchaseInvoiceUrl}/deletePurchaseInvoiceEntry`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseInvoiceModel)
            .catch(this.handleError);
    }

    addUpdatePurchaseInvoiceEntry(data: any): Promise<PurchaseInvoiceModel> {

        const url = `${this.purchaseInvoiceUrl}/addUpdatePurchaseInvoiceEntry`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseInvoiceModel)
            .catch(this.handleError);
    }

    getPurchaseReturnDetails(data: any): Promise<any> {
        const url = `${this.purchaseInvoiceUrl}/getPendingPurchaseReturnDetails`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseInvoiceModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/purchaseInvoice.service.ts